import React from "react";

import { handleEditorChange, prepareEditorContentImage } from "utils";

import { AdminSection, Col, Option, Row, Select, TextEditor } from "components";

export const NotificationContent = ({ articles, content, methods, news, notification, setArticle, setContent, type }) => (
  <>
    <AdminSection headline="Notification content" description="Choose the content of your notification." />
    {type === "article" && (
      <Row>
        <Col>
          <Select
            name="article"
            rules={[{ required: true }]}
            label="Article"
            popupMatchSelectWidth={false}
            showSearch
            filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            onChange={(v) => setArticle(v)}
            initialValue={notification && notification.article}
          >
            {articles.map((item, i) => (
              <Option value={item.id} key={i}>
                {item.title}
              </Option>
            ))}
          </Select>
        </Col>
      </Row>
    )}
    {(type === "feature" || type === "news") && (
      <Row>
        <Col>
          <Select
            name="news"
            rules={[{ required: true }]}
            label="News post"
            popupMatchSelectWidth={false}
            showSearch
            filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            onChange={(v) => setArticle(v)}
            initialValue={notification && notification.article}
          >
            {news.map((item, i) => (
              <Option value={item.id} key={i}>
                {item.title}
              </Option>
            ))}
          </Select>
        </Col>
      </Row>
    )}
    {type === "funding" && (
      <>
        <Row>
          <Col>
            <Select
              name="method"
              rules={[{ required: true }]}
              label="Method"
              popupMatchSelectWidth={false}
              showSearch
              filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              onChange={(v) => setArticle(v)}
              initialValue={notification && notification.article}
            >
              {methods.map((item, i) => (
                <Option value={item} key={i}>
                  {item}
                </Option>
              ))}
            </Select>
          </Col>
        </Row>
        <Row>
          <Col>
            <TextEditor
              init={{
                height: 250,
                images_upload_handler: (blobInfo, success) => {
                  prepareEditorContentImage({ file: blobInfo.blob(), location: "notifications" }).then((res) => success(res));
                },
              }}
              onEditorChange={(v) => handleEditorChange(v, setContent)}
              value={content}
            />
          </Col>
        </Row>
      </>
    )}
  </>
);
